import { parse, differenceInYears } from 'date-fns'

export function cpf(value) {
  if (value.length >= 14) return value.substring(0, 14)

  value = value.replace(/\D/g, '')

  if (value.length <= 11) {
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  } else {
    value = value.replace(/^(\d{2})(\d)/, '$1.$2')
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
    value = value.replace(/(\d{4})(\d)/, '$1-$2')
  }

  return value
}

export function date(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

export function phone(value) {
  return value
    .replace(/\D/g, '')
    .slice(0, 11)
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})$/, '$1-$2')
}

export function age(value) {
  const dob = parse(value, 'dd/MM/yyyy', new Date())

  const today = new Date()

  const age = differenceInYears(today, dob)

  if (Number.isNaN(age)) return ''

  return age + ' anos'
}

export const currency = (value) => {
  if (!value) return 'R$ 0,00'

  // Remove todos os caracteres não numéricos
  value = value.replace(/\D/g, '')

  // Formata o valor para o formato de moeda brasileira
  const numberValue = Number(value) / 100 // Divide por 100 para considerar os centavos

  value = numberValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return value
}

export const cep = (value) => {
  return value
    .replace(/\D/g, '')
    .slice(0, 8)
    .replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
}

export const text = (value) => {
  return value.replace('  ', ' ').replace(/[^a-zA-Zà-úÀ-Úä-üÄ-Ü`˜'ˆ ]+/g, '')
}

export const card = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1')
}

export const expiration = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1')
}

export const cvv = (value) => {
  return value.replace(/\D/g, '').substring(0, 3)
}

export const branch = (value) => {
  return value.replace(/\D/g, '')
}

export const account = (value) => {
  return value.replace(/\D/g, '')
}

export const digit = (value) => {
  return value.replace(/\D/g, '').substring(0, 1)
}

export const hour = (value) => {
  return value
  .replace(/\D/g, '')
  .slice(0, 4)
  .replace(/(\d{2})(\d)/, '$1:$2')
  .replace(/(\d{2})$/, '$1')
}

function passCode(input) {
  input = input.replace(/\D/g, '');
  
  if (input.length > 3) {
      input = input.slice(0, 3);
  }
  return input
}

function storeId(input) {
  input = input.replace(/\D/g, '');
  
  if (input.length > 3) {
      input = input.slice(0, 4);
  }
  return input
}


export const masks = {
  cpf,
  date,
  phone,
  age,
  currency,
  cep,
  text,
  cvv,
  card,
  expiration,
  branch,
  account,
  digit,
  hour,
  passCode,
  storeId
}
